/// <amd-module name="Search/Wiki/Constants" />

export const EntityTypeUrlParam = "wiki";

export namespace CustomerIntelligenceConstants {
    export const TTIScenarioName = "WikiSearchTTIScenario";
    export const TabSwitchScenarioName = "WikiSearchTabSwitchScenario";
    export const SubsequentSearchScenarioName = "WikiSearchTTIScenario";
    export const EntityName = "wiki";
    export const SearchStarted = "SearchStarted";
    export const ResultsLoaded = "ResultsLoaded";
    export const ZeroData = "ZeroData";
    export const NotificationBanner = "NotificationBanner";
    export const SearchInNewTab = "SearchInNewTab";
    export const SearchTextRemoved = "SearchTextRemoved";
    export const AccountLinkClicked = "AccountLinkClicked";
    export const AccountButtonClicked = "AccountButtonClicked";
    export const FeedbackLinkClicked = "FeedbackLinkClicked";
    export const FeedbackMailLinkClicked = "FeedbackMailLinkClicked";
    export const FilterResetClicked = "FilterResetClicked";

    export const ResultLinkClicked = "ResultLinkClicked";
    export const ResultLinkItemIndex = "WII";
    export const UrlParameterKeyTrackingData = "tracking_data";
    export const OrgSearchNavigationFromWikiSearchPageSource = "tfs.Search.wiki";
}

export const WikiSearchTakeResults = 50;
export const WikiSearchInfiniteScrollTakeResults = 25;
export const WikiSearchMaxSkipOrTakeResults = 1000;
export const WikiSearchLoadMoreTakeResults = 20;

export const FeedbackMailToLinkFormat =
    "mailto:vstssearch@microsoft.com?Subject=Feedback on Azure DevOps Services Wiki Search";
export const CodexFeedbackMailToLinkFormat =
    "https://developercommunity.visualstudio.com/report?space=21&version=NONE";
export const LearnMoreLink = "https://go.microsoft.com/fwlink/?linkid=862601";

export namespace RepoConstants {
    export const PathSeparator = "/";
}

export namespace PathConstants {
    export const Ampersand = "&";
    export const Colon = ":";
    export const Equal = "=";
    export const Hash = "#";
    export const Hyphen = "-";
    export const Lessthan = "<";
    export const Percent = "%";
    export const Pipe = "|";
    export const QuestionMark = "?";
    export const Quote = "\"";
    export const Slash = "/";
    export const Star = "*";
    export const Tilde = "~";
    export const Underscore = "_";
    export const WhiteSpace = " ";
}

export var WikiGitIllegalSpecialChars = [":", "?", "*", "<", ">", "-", "|", "\""];
export var WikiGitIllegalSpecialCharEcapes = [/%3A/g, /%3F/g, /%2A/g, /%3C/g, /%3E/g, /%2D/g, /%7C/g, /%22/g];

export namespace FormatConstants {
    export const MDFormat = ".md";
}

export const WikiControllerName = "wiki";
export const WikiResourceName = "wikis";

export class SearchConstants {
    public static ProjectFilterNew = "Project";
    public static WikiFacet = "Wiki";
}

export namespace WikiUrlParameters {
    export const PagePath = "pagePath";
    export const WikiVersion = "wikiVersion";
}

export namespace FilterKeys {
    export const ProjectFiltersKey: string = "Project";
}

export namespace FeatureFlagConstants {
    export const InfiniteScroll = "WebAccess.Search.Wiki.InfiniteScroll";
}